export default "__VITE_PUBLIC_ASSET__b977f455__"